module.exports = __webpack_public_path__ + "static/media/Onion.1fd04e36.png";